module.exports = __webpack_public_path__ + "static/img/96040C_2_3_R_20180429_n_fit.1bd4a97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/96040C_2_3_R_20180429_n_fit.png
// module id = sgs4
// module chunks = 0